/* 判断图片模式 */
// 三图模式
export var isThreeImage = function (thumbnails) {
    return !!thumbnails && typeof thumbnails === 'object' && thumbnails.image.length >= 3;
};
// 一图模式
export var isOneImage = function (thumbnails) {
    return !!thumbnails && typeof thumbnails === 'object' && thumbnails.image.length < 3 && thumbnails.image.length > 0;
};
// 有图
export var haveImage = function (thumbnails) {
    return !!thumbnails && typeof thumbnails === 'object' && thumbnails.image.length > 0;
};
// 获取图片地址
export var getImageUrl = function (item) { return item.picUrl ? item.picUrl : item.url; };
